///////////
///////////
///////////
///////////
///////////
///////////
///////////
///////////
///////////
///////////

// document groups:

// meetingSummary
// terms
// general

///////////
///////////
///////////
///////////
///////////
///////////
///////////
///////////















import axiosV2, { apiPost } from '../core/http/axios_api_v2';

export default {




    documentFilters: [
        {
            name: 'כל התבניות',
            templates: false,
            groupName: '',
            all: true
        },
        {
            name: 'תבניות סיכום פגישה',
            templates: true,
            groupName: 'meetingSummary'
        },
        {
            name: 'תבניות תנאי הסכם',
            templates: true,
            groupName: 'terms'
        },
        {
            name: 'תבניות מסמך כללי',
            templates: true,
            groupName: 'general'
        },
    ],

    documentGroups: [
        {
            name: 'סיכום פגישה',
            groupName: 'meetingSummary'
        },
        {
            name: 'תנאי הסכם',
            groupName: 'terms'
        },
        {
            name: 'מסמך כללי',
            groupName: 'general'
        }
    ],





    generateLocalEmptyDocument() {
        return {
            content: '',
            name: 'מסמך חדש',
            groupName: null,
            isTemplate: false,
            tags: [],
            id: null,
        }
    },


    //display name for template pickers: appends the template's tags so e.g.
    //"תנאי הסכם · השכרת שמלה" and "תנאי הסכם · מכירת שמלה" are distinguishable.
    //a name is never blank here - a nameless row would render as an empty option and
    //make the picker look like it has no templates at all
    templateDisplayName(template) {

        if (!template)
            return '';

        let name = (template.name && template.name.trim()) || 'מסמך ללא שם';

        if (template.tags && template.tags.length)
            return name + ' · ' + template.tags.join(', ');

        return name;
    },

    async saveDocument(documentData, hideSuccessAlert) {

        return apiPost('/documents', documentData, hideSuccessAlert).then(
            savedDocument => {

                documentData.id = savedDocument.id;

                this.updateDocumentInStore(documentData);
                
                return documentData;
            }
        );
    },


    updateDocumentInStore(document){

        let arrayToSaveDoc = null;

        switch (document.groupName) {

            case 'meetingSummary':
                    arrayToSaveDoc = window.planup.$store.state.documents.meetingSummaryTemplates;   
                break;

            case 'terms':
                arrayToSaveDoc = window.planup.$store.state.documents.termsTemplates;
                break;

            case 'general':
                arrayToSaveDoc = window.planup.$store.state.documents.generalTemplates;
                break;

            default:
                return;
        }


        let index = arrayToSaveDoc.findIndex(doc => doc.id === document.id);
        if (index === -1) {
            arrayToSaveDoc.push(document);
        } else {
            arrayToSaveDoc[index] = document;
        }



    },



    templateToDocument(template) {
        delete template.id;
        delete template.isTemplate;
        delete template.name;
    },


    async getDocument(id, callback) {

        //'undefined'/'null' arrive as strings from route queries built with a template
        //literal - a non-numeric id would 500 the API, so treat anything that isn't a
        //real id as "new document"
        if (!id || isNaN(+id))
            return this.generateLocalEmptyDocument();

        return axiosV2("/documents/" + id).then(

            response => {

                if (callback) {
                    callback(response.data)
                }

                return response.data;
            }
        );
    },


    async getPdf(id, callback) {

        if (!id)
            return this.generateLocalEmptyDocument();

        // iOS/iPadOS can't embed PDFs — ask for the server-rendered JPEG instead
        const jpegParam = window.planup.$globals.cantEmbedPdf ? '?jpeg=1' : '';

        return axiosV2("/pdf-documents/" + id + jpegParam).then(

            response => {

                if (callback) {
                    callback(response.data)
                }

                return response.data;
            }
        );
    },


    async openPdf_newWindow(id) {


        axiosV2("/pdf-documents/" + id).then(

            response => {

                let pdfWindow = window.open();

                pdfWindow.document.write(
                    "<style> body,html{margin:0;padding:0}</style> <iframe style='position:fixed;top:0;left:0;height:100vh;width:100vw' src='data:application/pdf;base64, " +
                    encodeURI(response.data.base64Content) + "'></iframe>"
                )

                pdfWindow.document.title = 'מסמך: ' + response.data.name;
            }
        );

    },

    async openPdf_modal(id, title) {

        let that = this;

        // iOS/iPadOS can't render a PDF inside an iframe — ask for the server-rendered JPEG. The
        // endpoint also answers phones with the JPEG on its own (by user agent), so the modal
        // shows whichever render came back: a JPEG as an image, the PDF in an iframe. Either
        // way the modal offers הורדת PDF — the file itself, for a device that shows neither.
        const jpegParam = window.planup.$globals.cantEmbedPdf ? '?jpeg=1' : '';

        axiosV2("/pdf-documents/" + id + jpegParam).then(

            response => {

                const doc = response.data;
                const modalTitle = title || ('מסמך: ' + doc.name);
                const download = { pdfId: id, fileName: that.pdfFileName(doc.name), base64Content: doc.base64Content };

                if (doc.base64JpegContent)
                    window.planup.$root.$emit('showGlobalPdfIframeModal', 'data:image/jpeg;base64,' + doc.base64JpegContent, modalTitle, true, download);
                else if (doc.base64Content)
                    window.planup.$root.$emit('showGlobalPdfIframeModal', that.base64ToBlobUrl(doc.base64Content), modalTitle, false, download);
                else
                    window.planup.AlertError('המסמך לא נמצא');
            }
        );
    },


    async updateName(documentData) {

        if (!documentData.id)
            return;

        this.updateDocumentInStore(documentData);

        return apiPost('/documents/updateName', documentData)
    },

    // async uploadPreview(documentId,canvas){

    //     return apiPost(`/documents/savePreviewImage/${documentId}`,{pngBase64:canvas.toDataURL()});
    // },


    // async getTemplates(withImages){
    //     if (withImages)
    //         return (await axiosV2('/documents/list?onlyTemplates=1&withImages=1')).data;

    //     return (await axiosV2('/documents/list?onlyTemplates=1')).data;
    // },


    async getList(withImages) {

        if (withImages)
            return (await axiosV2('/documents/list?withImages=1')).data;

        return (await axiosV2('/documents/list')).data;
    },


    async getGroup(groupName, withImages) {

        if (withImages)
            return (await axiosV2(`/documents/list/${groupName}?withImages=1`)).data;

        return (await axiosV2(`/documents/list/${groupName}`)).data;
    },


    getDocumentImageURL(id) {

        return `http://localhost:3000/apiv2/documents/getImage/${id}`;
    },


    async generateSigningLink(documentId, customerId) {
        return apiPost(`/documents/generateSigningLink/${documentId}`, { customerId });
    },

    // The PDF itself, whatever the device: bypasses the endpoint's mobile/jpeg branch (a phone
    // asking without ?pdf=1 gets the JPEG render by user agent) — for the הורדת PDF buttons.
    async getPdfForDownload(id) {
        return axiosV2("/pdf-documents/" + id + '?pdf=1').then(response => response.data);
    },

    // The file name a PDF is saved under (a document title, or the pdf_document name)
    pdfFileName(name) {
        return String(name || 'מסמך').replace(/[\\/]+/g, '-').replace(/[:*?"<>|]+/g, ' ').trim() + '.pdf';
    },

    // Saves a PDF to the device — the answer for a phone / iPad that can't display it inline.
    // download = { fileName, base64Content?, pdfId? }: bytes already at hand are saved as they
    // are, otherwise the pdf_document is fetched (the PDF itself, never the JPEG render).
    // file-saver picks the route per browser: <a download> on a blob url where supported
    // (desktop, Android, iOS 13+), a new tab elsewhere. Resolves true once handed to the browser.
    async downloadPdf(download) {

        if (!download)
            return false;

        let base64Content = download.base64Content;
        let fileName = download.fileName;

        if (!base64Content && download.pdfId) {

            let data = null;

            try {
                data = await this.getPdfForDownload(download.pdfId);
            } catch (e) {
                data = null;
            }

            if (data) {
                base64Content = data.base64Content;
                fileName = fileName || this.pdfFileName(data.name);
            }
        }

        if (!base64Content) {
            window.planup.AlertError('הורדת המסמך נכשלה');
            return false;
        }

        window.planup.$globals.saveAs(this.base64ToBlob(base64Content), fileName || this.pdfFileName());
        return true;
    },

    base64ToBlobUrl(b64Data) {
        return URL.createObjectURL(this.base64ToBlob(b64Data)) + '#toolbar=0';
    },

    base64ToBlob(b64Data) {

        const sliceSize = 512;
        const contentType = 'application/pdf';
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    },

}